import * as React from "react";
import { forwardRef } from "react";
const SvgIconPath = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 6H0V27C0 28.65 1.35 30 3 30H24V27H3V6ZM27 0H9C7.35 0 6 1.35 6 3V21C6 22.65 7.35 24 9 24H27C28.65 24 30 22.65 30 21V3C30 1.35 28.65 0 27 0ZM27 21H9V3H27V21ZM12 10.5H24V13.5H12V10.5ZM12 15H18V18H12V15ZM12 6H24V9H12V6Z", fill: "#525A5C" }));
const ForwardRef = forwardRef(SvgIconPath);
export default ForwardRef;
